export { default as default } from './modules/read/readXlsxFileBrowser.js'
export { default as readSheetNames } from './modules/read/readSheetNamesBrowser.js'
export { default as parseExcelDate } from './modules/read/parseDate.js'
export { default as Integer } from './modules/types/Integer.js'
export { default as Email } from './modules/types/Email.js'
export { default as URL } from './modules/types/URL.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/read-excel-file/index.js
// module id = null
// module chunks = 